import IconBuilding16 from '@warp-ds/icons/react/building-16';
import IconCar16 from '@warp-ds/icons/react/car-16';
import IconPinMarker16 from '@warp-ds/icons/react/pin-marker-16';
import IconPlaneLand16 from '@warp-ds/icons/react/plane-land-16';
import IconPlaneTakeOff16 from '@warp-ds/icons/react/plane-take-off-16';

import type { AutocompleteOption, AutocompleteProps } from '../../../../types/index';

interface AutocompleteIconProps {
    option: AutocompleteOption | null;
    vertical: AutocompleteProps['vertical'];
    departure?: AutocompleteProps['departure'];
    className?: string;
}

export const AutocompleteIcon = ({ option, vertical, className, departure = true }: AutocompleteIconProps) => {
    const iconProps = { 'aria-hidden': true, className };

    if (vertical === 'flight' && option?.locationType === 'CITY') {
        return <IconPinMarker16 {...iconProps} />;
    }

    if (vertical === 'flight' && departure === false) {
        return <IconPlaneLand16 {...iconProps} />;
    }

    if (vertical === 'hotel' && option?.type === 'hotel') {
        return <IconBuilding16 {...iconProps} />;
    }

    if (vertical === 'car' && option?.type === 'Flyplass') {
        return departure ? <IconPlaneTakeOff16 {...iconProps} /> : <IconPlaneLand16 {...iconProps} />;
    }

    if (vertical === 'car' && option?.type === 'By / Område') {
        return <IconPinMarker16 {...iconProps} />;
    }

    switch (vertical) {
        case 'flight':
            return <IconPlaneTakeOff16 {...iconProps} />;
        case 'hotel':
            return <IconPinMarker16 {...iconProps} />;
        case 'car':
            return <IconCar16 {...iconProps} />;
        case 'prepackage':
            return <IconPinMarker16 {...iconProps} />;
        case 'fhh':
            return <IconPinMarker16 {...iconProps} />;
        default:
            return null;
    }
};
